





















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LoaderMixin from "@/mixins/loader";
import { getUserSubmissions, downloadFile } from "@/services/api/submission";
import NotificationMixin from "../../mixins/notification";
import { saveAs } from "file-saver";
import SubmissionForm from "@/components/dialogs/admin/SubmissionForm.vue";
import ProofcheckForm from "@/components/dialogs/admin/ProofcheckForm.vue";
import SetProofreader from "@/components/dialogs/admin/SetProofreader.vue";
import ProofreadsSummary from "@/components/dialogs/admin/ProofreadsSummary.vue";
import Users from "@/components/admin/Users.vue";

interface Submission {
  id: number;
  title: string;
  status: string;
  created_at: string;
  color: string;
  isProofReader: boolean;
}

@Component({
  components: {
    SubmissionForm,
    ProofcheckForm,
    SetProofreader,
    ProofreadsSummary,
    Users
  }
})
export default class Submissions extends mixins(
  LoaderMixin,
  NotificationMixin
) {
  private isProofreader = false;
  private isAdmin = false;
  private activeTab: any = null;
  private showRevisionDialog: boolean = false;
  private showSetProofreaderDialog: boolean = false;
  private showProofreaderSummaryDialog: boolean = false;
  private submissionId: number = 0;
  private loading = false;
  private refreshing = false;
  private search = "";
  private selected: any = [];
  private date: Date = null;
  private status = "";
  private headers = [
    {
      text: "#",
      align: "left",
      value: "noth",
      sortable: false
    },
    {
      text: "Número",
      align: "center",
      value: "id"
    },
    { text: "Título", align: "center", value: "title" },
    { text: "Status", align: "center", value: "status" },
    { text: "Data de submissão", align: "center", value: "created_at" },
    { text: "", align: "center", value: "actions" }
  ];

  private submissions: any = [];

  @Watch("selected")
  selectedChanged(newVal: any) {
    if (newVal.length > 1) {
      this.selected.shift();
    }
  }

  private created() {
    this.verifyUser();
    this.loadData();
  }

  private loadData() {
    this.loading = true;
    this.refreshing = true;

    getUserSubmissions(this.$store.state.user.id)
      .then(result => {
        if (result.success) {
          if (result.data.proofreader_submissions) {
            this.filterResults(result.data.proofreader_submissions, true)
            this.filterResults(result.data.own_submissions)

            let subResp = result.data.proofreader_submissions;
            subResp = subResp.concat(result.data.own_submissions);

            this.submissions = subResp;
          } else {

            this.filterResults(result.data, this.isAdmin ? true : false);
            this.submissions = result.data;
          }
        } else {
          this.showErrorNotification(
            "Não foi possível carregar as submissões."
          );
        }

        this.loading = false;
        this.refreshing = false;
      })
      .catch(err => {
        console.log(err);
        this.showErrorNotification(
          "Ocorreu um erro ao carregar as submissões."
        );
        this.refreshing = false;
        this.loading = false;
      });
  }

  private verifyUser() {
    this.isProofreader = this.$store.state.user.type === "proofreader";
    this.isAdmin = this.$store.state.user.type === "admin";
  }

  private downloadFile(fileUrl: string, title: string) {
    this.loading = true;
    downloadFile(
      fileUrl.substring(fileUrl.lastIndexOf("/") + 1, fileUrl.length) // gambi braba
    )
      .then(file => {
        saveAs(file, title);
        this.loading = false;
      })
      .catch(err => {
        this.showErrorNotification(
          "Ocorreu um erro ao realizar o download do arquivo."
        );
        this.loading = false;
      });
  }

  private mapStatus(status: string) {
    if (status === "pendente") {
      return { color: "", text: "PENDENTE" };
    } else if (status === "revisao") {
      return { color: "warning", text: "EM REVISÃO" };
    } else if (status === "reprovado") {
      return { color: "error", text: "NÃO ACEITO" };
    } else if (status === "aprovado") {
      return { color: "success", text: "ACEITO" };
    }
  }

  private filterResults(items: any[], isProofReader = false) {
    return items.map((item: Submission) => {
      item.created_at = new Date(item.created_at).toLocaleDateString();
      item.color = this.mapStatus(item.status).color;
      item.status = this.mapStatus(item.status).text;
      item.isProofReader = isProofReader;
    });
  }

  private showProofread(submissionId: number) {
    this.submissionId = submissionId;
    this.showRevisionDialog = true;
  }

  private hideProofreadDialog() {
    this.showRevisionDialog = false;
  }

  private showSetProofreader(seletedItems: any) {
    this.showSetProofreaderDialog = true;
  }

  private hideSetProofreader() {
    this.showSetProofreaderDialog = false;
  }

  private showSummary(submissionId: number, status: string) {
    this.status = status;
    this.submissionId = submissionId;
    this.showProofreaderSummaryDialog = true;
  }

  private hideSummary() {
    this.showProofreaderSummaryDialog = false;
  }
}
